import React from 'react';
import { Link } from 'react-router';
import { SEOHelmet } from 'components/SEO';
import { PlayLayout } from './layout/PlayLayout';

/** Unknown or reserved-looking segment under /play, or a code the backend does not know. */
export const PlayNotFound: React.FC<{ reason?: 'invalid' | 'missing' }> = ({ reason = 'invalid' }) => (
  <PlayLayout>
    <SEOHelmet title="Tournament not found - TradeMagic Play" description="This TradeMagic Play link doesn't point at a tournament." noindex />
    <div className="play-notfound" data-testid="play-not-found">
      <p className="play-eyebrow">TradeMagic Play</p>
      <h1 className="play-title">{reason === 'missing' ? "We couldn't find that tournament" : "That link doesn't look right"}</h1>
      <p className="play-helper">Check the invite link with your organizer, or host your own event.</p>
      <p style={{ marginTop: 16 }}>
        <Link to="/play" className="play-secondary-button" style={{ width: 'auto' }}>
          Go to TradeMagic Play
        </Link>
      </p>
    </div>
  </PlayLayout>
);

export default PlayNotFound;
